import React, { useState } from 'react';
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import styled from '@emotion/styled';
import ButtonsGroup from '../common/ButtonsGroup';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const Wrapper = styled(ResponsiveContainer)`
  .recharts-wrapper .recharts-cartesian-grid-vertical line:nth-last-of-type(-n + 2) {
    stroke-opacity: 0;
  }

  .recharts-tooltip-item {
    padding: 0 !important;
    margin-top: 2px;
  }
`;

const CardWrapper = styled(`div`)`
  .header-title {
    display: flex;
    height: 26px;
    align-items: center;

    .switch-wrapper {
      display: flex;
      font-size: 13px;
      flex-wrap: nowrap;
      align-items: center;
      margin-left: 24px;

      .custom-switch {
        cursor: pointer;
      }
    }
  }
`;

const rangeToDataName = {
  week: `weeklyValue`,
  month: `monthlyValue`,
  year: `annuallyData`,
};

const DeliveryDynamicsChart = (props) => {
  const [range, setRange] = useState(`year`);
  // const isElemsMoreThan = (qty) => props[rangeToDataName[range]]?.length > qty;

  const { t } = useAutoTranslation();
  return (
    <>
      <div className="col-xl-4">
        <CardWrapper className="card">
          <div className="card-body">
            <div className="float-right d-none d-md-inline-block">
              <ButtonsGroup
                className="mb-2"
                data={[
                  { value: 'week', label: t('Неделя') },
                  { value: 'month', label: t('Месяц') },
                  { value: 'year', label: t('Год') },
                ]}
                currentValue={range}
                onChange={setRange}
              />
            </div>
            <h4 className="header-title">{t('Каналы доставки')}</h4>
            <div className="row mt-4 text-center"></div>
            <div className="mt-3">
              <Wrapper width="100%" height={360}>
                <BarChart
                  width={830}
                  height={250}
                  data={props[rangeToDataName[range]]}
                  margin={{ top: 0, right: 30, left: 0, bottom: 0 }}
                  layout="vertical"
                >
                  <YAxis
                    dataKey="point"
                    tick={{ fill: `#98a6ad` }}
                    type="category"
                    interval={0}
                    name="city"
                    width={180}
                    padding={{ left: 20, right: 20 }}
                    tickLine={false}
                  />
                  <XAxis type="number" />
                  <Bar dataKey="currentValue" fill="#4fc6e1" barSize={8} />{' '}
                  <Tooltip
                    cursor={false}
                    formatter={(value) => [value]}
                    labelFormatter={(key) => key}
                    contentStyle={{
                      border: `none`,
                      boxShadow: `0 1px 4px 0 rgba(0, 0, 0, 0.1)`,
                      borderRadius: `0.25rem`,
                      opacity: `0.95`,
                      fontWeight: 500,
                      backdropFilter: `blur(2px)`,
                    }}
                    labelStyle={{ fontWeight: 600, marginBottom: 5 }}
                  />
                </BarChart>
              </Wrapper>
            </div>
          </div>
        </CardWrapper>
      </div>
    </>
  );
};

export default DeliveryDynamicsChart;
